module.exports = __webpack_public_path__ + "static/img/img_gzhj4_2x.c5c0425.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/aboutus/img/img_gzhj4_2x.jpg
// module id = QsaJ
// module chunks = 0